/* eslint-disable @typescript-eslint/no-explicit-any */
import { assert } from '../../utils/assert.js';
import { GamoraFoundationNodeRoot } from './node.js';

/**
 * GamoraFoundationNodeArgs
 *
 * Mandatory node arguments
 * @internal
 */
export interface GamoraFoundationSuperNodeArgs {
  super?: GamoraFoundationNodeRoot;
}

/**
 * GamoraFoundationSuperNode
 *
 * Abstract class that represents a super root node
 * @class
 * @public
 */
export abstract class GamoraFoundationSuperNode<
  TSuper extends GamoraFoundationNodeRoot = any,
> {
  private _$super: GamoraFoundationNodeRoot | undefined;
  constructor(args: GamoraFoundationSuperNodeArgs) {
    this._$super = args.super;
  }

  /**
   * Expose super root
   */
  get $super() {
    assert(this._$super !== undefined, '$super is not set.');
    return this._$super as TSuper;
  }
}
